export default "__VITE_ASSET__xLo9oqWV__"